import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const NaoConformidadesFornecedoresConfig: EntityConfig = [
  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },{
    id: 'referencia',
    label: 'Referência',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'entradaMaterial',
    label: 'Entrada material',
    type: 'select',
    nonEditable: true,
    routable: true,
    options: {
      label: 'id',
      route: 'entradas-material',
      value: 'id'
    }
  },
  {
    id: 'motivoNaoConformidade',
    type: 'text',
    label: 'Motivo'
  },
  {
    id: 'accoesImediatasNaoConformidade',
    type: 'text',
    label: 'Acções Imediatas'
  },
  { 
    id: 'designacaoNaoConformidade',
    type: 'text',
    label: 'Designação'
  },
  {
    id: 'observacoesNaoConformidade',
    type: 'text',
    label: 'Observações'
  },{
    id: 'anexos',
    label: 'Documentos anexos',
    type: 'anexos',
    options: {
      anexosEndpointBuildFunction: (id: number | string) => `/nao-conformidades-fornecedores/${id}/anexos`
    }
  },
];
